import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import ServiceAuth from './ServiceAuth';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface ServiceAuthModalProps {
  open: boolean;
  onClose: () => void;
  intent: 'shuttle' | 'equipment' | 'marketplace' | null;
}

const ServiceAuthModal: React.FC<ServiceAuthModalProps> = ({
  open,
  onClose,
  intent,
}) => {
  const user = useSelector((state: RootState) => state.auth.user);
  const isPilot = user?.is_pilot;

  const handleAuthenticated = (userData: any) => {
    console.log('[ServiceAuthModal] handleAuthenticated called, intent:', intent);
    // Simply close the modal - navigation is now handled in ServiceAuth
    onClose();
  };

  // Auto-navigate for pilots
  useEffect(() => {
    if (open && isPilot && intent) {
      // Pilots get auto-provisioned, so we can navigate directly
      // The ServiceAuth component will handle the provisioning
    }
  }, [open, isPilot, intent]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          position: 'relative',
          overflow: 'visible',
        }
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: -12,
          top: -12,
          bgcolor: 'background.paper',
          color: (theme) => theme.palette.grey[700],
          border: (theme) => `2px solid ${theme.palette.divider}`,
          boxShadow: 2,
          '&:hover': {
            bgcolor: 'background.paper',
            transform: 'scale(1.1)',
          },
          zIndex: 1,
        }}
      >
        <Close />
      </IconButton>
      
      <DialogContent sx={{ pt: 3, pb: 4, px: 3 }}>
        <ServiceAuth
          onAuthenticated={handleAuthenticated}
          intent={intent}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ServiceAuthModal;